import { render, staticRenderFns } from "./TaxReturnShortTermDebtSection.vue?vue&type=template&id=146e98fd&scoped=true&"
import script from "./TaxReturnShortTermDebtSection.vue?vue&type=script&lang=js&"
export * from "./TaxReturnShortTermDebtSection.vue?vue&type=script&lang=js&"
import style0 from "./TaxReturnShortTermDebtSection.vue?vue&type=style&index=0&id=146e98fd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146e98fd",
  null
  
)

export default component.exports